import React from 'react';
import { toast } from 'react-toastify';
import { ReactComponent as IconClose } from '../Icons/shared/ic-shared-close.svg';
import { ReactComponent as IconVMark } from '../Icons/shared/ic-shared-checkmark-circle.svg';
import '../../index.css';

export const LiliToastDefaultConfig = {
  autoClose: 3000,
  closeOnClick: false,
  closeButton: false,
  hideProgressBar: true,
  draggable: false,
  position: toast.POSITION.TOP_CENTER,
};

interface LiliToastProps {
  text: string;
  showCloseButton?: boolean;
  id: string;
}

const LiliToast = (props: LiliToastProps) => {
  const { text, showCloseButton, id } = props;

  return (
    <div className='bg-bw08 items-center flex px-[14px] py-[10px] h-[44px] min-h-[44px] rounded-md' id={id}>
      <IconVMark className='w-[20px] h-[20px] mr-[8px] text-bw00' />
      <div className='font-metricR text-md text-bw00'>{text}</div>
      {showCloseButton && (
        <IconClose className='w-[20px] h-[20px] ml-[8px] text-bw00 cursor-pointer' onClick={() => toast.dismiss()} />
      )}
    </div>
  );
};

export default LiliToast;
